import { useFilterChecker, useSearch, useSort } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'

import FilterModal from './FilterModal'
import IconsBar, { IconsBarItem } from '../../../../components/list/IconsBar'
import UsersSearchInput from './query/UsersSearchInput'
import UsersSortModal from './sort/UsersSortModal'

// TODO: Move to generic logic and presentation FilterControlBar
const ServiceOrdersControlBar = () => {
  const { t } = useTranslation('common')

  const [isSearching, setIsSearching] = useState(false)
  const hideSearch = () => setIsSearching(false)
  const showSearch = () => setIsSearching(true)

  const [isFiltering, setFiltering] = useState(false)
  const hideFilter = () => setFiltering(false)
  const showFilter = () => setFiltering(true)

  const [isSorting, setIsSorting] = useState(false)
  const hideSort = () => setIsSorting(false)
  const showSort = () => setIsSorting(true)

  const hasQuery = !!useSearch()
  const hasSort = !!useSort().field
  const { hasFilter } = useFilterChecker()

  if (isSearching) {
    return (
      <IconsBar>
        <UsersSearchInput hideSearch={hideSearch} />
      </IconsBar>
    )
  }

  return (
    <div>
      <UsersSortModal open={isSorting} onClose={hideSort} />
      <FilterModal open={isFiltering} onClose={hideFilter} />

      <IconsBar>
        <IconsBarItem iconName="BsArrowDownUp" label={t('sort')} onClick={showSort} alertNote={hasSort} />
        <IconsBarItem iconName="BsFunnel" label={t('filter')} onClick={showFilter} alertNote={hasFilter} />
        <IconsBarItem
          iconName="BsSearch"
          iconSize="1rem"
          label={t('search')}
          onClick={showSearch}
          alertNote={hasQuery}
        />
      </IconsBar>
    </div>
  )
}

export default ServiceOrdersControlBar
